import React from "react";
import { Column } from "../../../table/Column";
import { CellRenderer } from "./CellRenderer";
import { Table } from "../../../table/Table";
import { parseDate, normalizeString } from "./utils/helpers";
import { Radio } from "./styles";
export var SimilarResidentsTable = function (_a) {
    var _b = _a.similarResidents, similarResidents = _b === void 0 ? [] : _b, _c = _a.activeRowId, activeRowId = _c === void 0 ? "" : _c, _d = _a.selectable, selectable = _d === void 0 ? true : _d, residentFilesModal = _a.residentFilesModal, formValues = _a.formValues;
    return (React.createElement(Table, { data: similarResidents.filter(function (resident) { return resident.match !== "100%"; }), activeRowId: activeRowId, getRowId: function (_a) {
            var rowData = _a.rowData;
            return rowData.resident.id;
        } },
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return (React.createElement(Radio, { visible: 
                    // Not selectable when creating new resident through form
                    selectable, onClick: function (e) {
                        e.stopPropagation();
                    }, name: "resident_demographics.similar_resident", type: "radio", value: rowData.resident.id }));
            }, width: 100 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "First name",
                    value: rowData.resident.first_name || "—",
                }, normalizeString(formValues.first_name) ===
                    normalizeString(rowData.resident.first_name));
            }, label: "First Name", width: 250 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "Last name",
                    value: rowData.resident.last_name || "—",
                }, normalizeString(formValues.last_name) ===
                    normalizeString(rowData.resident.last_name));
            }, label: "Last Name", width: 250 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({ label: "Gender", value: rowData.resident.gender || "—" }, formValues.gender === rowData.resident.gender);
            }, label: "Gender", width: 150 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "Date of birth",
                    value: rowData.resident.date_of_birth
                        ? parseDate(rowData.resident.date_of_birth)
                        : "—",
                }, formValues.date_of_birth === rowData.resident.date_of_birth);
            }, label: "Date of Birth", width: 150 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "Resident ID",
                    value: rowData.resident.resident_id || "—",
                }, true);
            }, label: "Resident ID", width: 150 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "EHR ID",
                    value: rowData.resident.pcc_patient_id || "—",
                }, true);
            }, label: "EHR ID", width: 150 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData;
                return CellRenderer({
                    label: "MRN",
                    value: rowData.resident.mrn || "—",
                }, true);
            }, label: "MRN", width: 150 }),
        React.createElement(Column, { cellRenderer: function (_a) {
                var rowData = _a.rowData, rowIndex = _a.rowIndex;
                return (React.createElement("div", { style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "16px",
                    } }, residentFilesModal({
                    rowData: rowData,
                    rowIndex: rowIndex,
                })));
            }, width: 150 })));
};
